import {Platform} from 'react-native';
import {WEB_APP_BASE_URL} from 'config/app.config';

/**
 * Try Quik Demo, the "Try Quik Demo" button on quiklearn.ai (owner 2026-10-13: "Make sure that still works but with
 * new UI. But that should not be having any reward store etc. All that can do is lesson, quiz and tutor as per
 * original plan and offers only 1 minute of voice and 3 minutes of text. And right after quota is exhausted, take
 * user to login screen."; Sol ~/.claude/sol-runs/quiklearn-guided/prod-demo.verdict.md D1 A, D2 A, D3 A).
 *
 * ?showTrialDemo=true starts it. Each visitor gets their own demo account from POST /api/auth/anonymous, which the
 * server marks as a demo account (60 s voice, 180 s text, no guided first visit); the same visitor keeps it.
 */
const FLAG_KEY = 'quiklearn.trial-demo';
export const DEMO_ACCOUNT_KEY = 'quiklearn.trial-demo.account';

// The original demo's unit ("as per original plan"): Grade 5 History, The American Revolution (5H_P6).
export const DEMO_CURRICULUM_ID = '39dfd566-be3e-442d-b32a-d50f2c235208';
export const DEMO_UNIT_ID = 'ba973689-77ce-4f4c-aa61-b9f01bb4c8fa';

const onWeb = () => Platform.OS === 'web' && typeof window !== 'undefined';

export const demoLoginUrl = () => `${WEB_APP_BASE_URL}/login`;

/** Whether this tab is running the demo: the start link, or a demo launched earlier in this tab. */
export const isTrialDemo = () => {
  if (!onWeb()) return false;
  try {
    if (new URLSearchParams(window.location.search).get('showTrialDemo') === 'true') return true;
    return window.sessionStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

export const markTrialDemo = () => {
  if (!onWeb()) return;
  try {
    window.sessionStorage.setItem(FLAG_KEY, '1');
  } catch {
    // private mode: the query parameter still marks the demo for this page load
  }
};

/**
 * A normal launch (a launch without showTrialDemo) ends the demo in this tab, so a demo visitor who signs in and opens
 * the real app in the same tab gets everything back.
 */
export const clearTrialDemo = () => {
  if (!onWeb()) return;
  try {
    window.sessionStorage.removeItem(FLAG_KEY);
  } catch {
    // nothing stored
  }
};

const SESSION_KEY = 'quiklearn.trial-demo.session';
/** One id per demo run in this tab, for the demo's analytics events (Sol mixpanel-coverage D1 A). */
export const demoSessionId = () => {
  if (!onWeb()) return null;
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `d_${Math.random().toString(16).slice(2, 18)}`;
      window.sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};

let leaving = false;
/** The demo's minutes are used up: straight to the login screen, once (Sol prod-demo D3 A). */
export const leaveDemoForLogin = () => {
  if (!onWeb() || leaving) return;
  leaving = true;
  window.location.assign(demoLoginUrl());
};
